import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentComponent } from './shared/components/layout/content/content.component';
import { content } from './shared/routes/routes';
import { AuthGuard } from './shared/guards/auth.guard';
import { SinglePageComponent } from './components/single-page/single-page.component';

const routes: Routes = [
	{
		path: '',
		canActivate: [AuthGuard],
		component: ContentComponent,
		children: content
	},
	{
		path: 'not-found',
		canActivate: [AuthGuard],
		component: SinglePageComponent
	},
	{
		path: '**',
		redirectTo: 'not-found'
	}
];

@NgModule({
	imports: [
		[
			RouterModule.forRoot(routes, {
				anchorScrolling: 'enabled',
				scrollPositionRestoration: 'enabled'
			})
		]
	],
	providers: [AuthGuard],
	exports: [RouterModule]
})
export class AppRoutingModule {}
